export default __webpack_public_path__ + "static/media/healthcare.97ec0ff4.jpg";